export const ROUTE_META_DATA = {
  home: {
    metaTitle: 'TRP DeFi Liquidity Pools on [network_name]',
    metaDescription:
      'Explore DeFi liquidity pools or create your own. Provide liquidity to accumulate yield from swap fees while retaining your token exposure as prices move',
    metaKeywords: '',
  },
  pool: {
    metaTitle: '[pool_symbol]',
    metaDescription: '[pool_name] — a Risk Protocol [pool_type] pool',
  },
  swap: {
    metaTitle: 'Swap DeFi tokens on [network_name]',
    metaDescription:
      'Swap ERC-20 tokens using Risk Protocol liquidity pools with intelligent routing across DeFi exchanges',
  },
  claim: {
    metaTitle: 'Claim liquidity mining incentives from staking',
    metaDescription:
      'LPs who stake can claim liquidity mining incentives. veBAL holders can boost incentives and claim their share of protocol revenue',
  },
  portfolio: {
    metaTitle: 'Risk Protocol Portfolio',
    metaDescription:
      'Track your Risk Protocol portfolio, including your unstaked and staked LP positions',
  },
  vebal: {
    metaTitle: 'veBAL tokenomics',
    metaDescription:
      'Get veBAL (voter escrowed B-80BAL-20WETH) for extra liquidity mining incentives, governance voting power and a share of protocol revenue',
  },
  'terms-of-use': {
    metaTitle: 'Risk Protocol Terms of Use',
    metaDescription: 'The rules for the use of the website',
  },
  'privacy-policy': {
    metaTitle: 'Risk Protocol Privacy Policy',
    metaDescription:
      'How this website collects, uses and shares personal information',
  },
  'cookies-policy': {
    metaTitle: 'Risk Protocol Cookie Policy',
    metaDescription: 'How this website uses browser cookies',
  },
  risks: {
    metaTitle: 'Risk Protocol Risks',
    metaDescription: 'The risks of using the Risk Protocol',
  },
};
